import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { priorityOptions, statusOptions } from '../../../../utils/OptionUtils';
import AsyncSelect from 'react-select/async';

const EditSubscriptionTicketDetailsModal = ({ show, handleClose, handleUpdate, planData, usersList, ticket }) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [users, setUsers] = useState([]);

    const { formState: { errors }, control, handleSubmit, register, setValue, reset, watch } = useForm({
        defaultValues: {
            checklist_id: ticket.checklist.id || "",
            priority: ticket.priority || "",
            status: ticket.status || "",
            assigned_to: ticket.assigned_to|| "",
            title: ticket.title || "",
            description: ticket.description || ""
        }
    });
    useEffect(() => {
        if (usersList && usersList.length > 0) {
            setUsers(usersList);
        }
    }, [usersList]);

    useEffect(() => {
        if (!ticket || users.length === 0) {
            return;
        }
        const result = users.find(user => user.value === ticket?.assignedTo?.id) || null;
        setSelectedUser(result);
        reset({
            checklist_id: ticket?.checklist.id || "",
            priority: ticket?.priority || "",
            status: ticket?.status || "",
            assigned_to: ticket?.assignedTo?.id || "",
            title: ticket?.title || "",
            description: ticket?.description || ""
        });
    }, [ticket, users, reset]);

    return (
        <Modal show={show} onHide={handleClose} className='modal-lg'>
            <Modal.Header closeButton>
                <Modal.Title>Update Ticket</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(handleUpdate)}>
                    {planData && (
                        <div key={planData.id} className="mb-4">
                            <h3 className="text-primary text-center mb-3">{planData.name}</h3>
                            <div className="mb-3">
                                <div className="ps-3 row">
                                    {planData.checklists?.map((checklist) => (
                                        <div className="col-6 col-md-6" key={checklist.id}>
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id={`checklist-${checklist.id}`}
                                                    value={checklist.id}
                                                    {...register('checklist_id', { required: true })}
                                                    checked={String(watch("checklist_id")) === String(checklist.id)}
                                                    onChange={() => {
                                                        console.log("🔍 watch(checklist_id):", watch("checklist_id")); 
                                                        console.log("🔍 checklist.id:", checklist.id); 
                                                        console.log("✅ Equality check:", watch("checklist_id") === checklist.id);

                                                            setValue("checklist_id", checklist.id)
                                                        }
                                                    } 
                                                />
                                                <label
                                                    htmlFor={`checklist-${checklist.id}`}
                                                    className="form-check-label"
                                                >
                                                    {checklist.name}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                {errors.checklist_id && (
                                    <p className="text-danger mt-3">Please select a checklist to proceed.</p>
                                )}
                            </div>
                            <div className="row mt-3">
                                <div className="col-6">
                                    <label className="fw-bold">Priority</label>
                                    <Controller
                                        name="priority"
                                        control={control}
                                        render={({ field }) => (
                                            <select
                                                {...field}
                                                className="form-select"
                                                value={field.value || ''}
                                                onChange={(e) => field.onChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Select a priority
                                                </option>
                                                {priorityOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    />
                                    {errors.priority && (
                                        <p className="text-danger mt-2">Priority is required.</p>
                                    )}
                                </div>
                                <div className="col-6">
                                    <label className="fw-bold">Status</label>
                                    <Controller
                                        name="status"
                                        control={control}
                                        render={({ field }) => (
                                            <select
                                                {...field}
                                                className="form-select"
                                                value={field.value || ''}
                                                onChange={(e) => field.onChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Select a status
                                                </option>
                                                {statusOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    />
                                    {errors.status && (
                                        <p className="text-danger mt-2">Status is required.</p>
                                    )}
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-6">
                                    <label className="fw-bold">Assign</label>
                                    <Controller
                                        name='assigned_to'
                                        control={control}
                                        render={({ field }) => (
                                            <AsyncSelect
                                                {...field}
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={usersList}
                                                onChange={(selectedOption) => {
                                                    setSelectedUser(selectedOption);
                                                    field.onChange(selectedOption ? selectedOption.value : null);
                                                }}
                                                value={selectedUser}
                                            />
                                        )}
                                    />
                                    {errors.assigned_to && (
                                        <p className="text-danger mt-2">Assign field is required.</p>
                                    )}
                                </div>
                                <div className="col-6">
                                    {/* Placeholder for another 6-column field */}
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="fw-bold">Title</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Title"
                                        {...register('title', { required: true, maxLength: 100 })}
                                    />
                                    {errors?.title && (
                                        <p className="text-danger mt-2">Title is required.</p>
                                    )}
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="fw-bold">Description</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter description"
                                        {...register('description', { required: true, maxLength: 255 })}
                                    />
                                    {errors.description && (
                                        <p className="text-danger mt-2">Description is required.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="modal-footer">
                        <Button variant="danger" onClick={handleClose}>
                            Close
                        </Button>
                        <Button type="submit" variant="primary">
                            Save
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default EditSubscriptionTicketDetailsModal;
